import { motion } from "framer-motion";

export default function VideoSection() {
  return (
    <section className="video-section" data-testid="home-video-section">
      <div className="container">
        <motion.div
          className="section-head video-head"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="eyebrow">En vidéo</div>
          <h2>Une minute pour<br />tout comprendre</h2>
          <p>Les guides, la méthode et la promesse — racontés en images.</p>
        </motion.div>

        <motion.div
          className="method-video"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="method-video-frame">
            <video
              controls
              preload="none"
              playsInline
              poster="/videos/methode-poster.jpg"
              src="/videos/methode.mp4"
              data-testid="home-video-player"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
